import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFiles, resetState, StateStatus } from '@guryou/redux';

import { ActionStatus, buildActionType } from '../core';
import {
  ADD_FILE_TO_SECTION,
  CREATE_FILE,
  DELETE_ALL_FILES_IN_SECTION,
  DELETE_FILE,
  FILES,
  FILES_REORDER,
  SECTIONS,
  UPDATE_FILE,
  UPLOAD_FILE,
} from '../new';

const useFiles = ({ sectionId, silent, toResetModal = true }) => {
  const dispatch = useDispatch();

  const { data, status, version, entity, request } = useSelector(state => state.files.all);
  const { update, upload, create, remove, reorder, addToSection, deleteAllFilesInSection } = useSelector(state => state.files);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request?.sectionId !== sectionId)) {
      dispatch(getFiles(sectionId, silent));
    }
    if (update.version || remove.version || reorder.version || addToSection.version || create.version || deleteAllFilesInSection.version) {
      update.version && dispatch(resetState(UPDATE_FILE));
      upload.version && dispatch(resetState(UPLOAD_FILE));
      reorder.version && dispatch(resetState(FILES_REORDER));
      if (deleteAllFilesInSection.version) {
        dispatch({ type: buildActionType(SECTIONS, ActionStatus.UPDATE), index: deleteAllFilesInSection.data?.sectionIndex });
        dispatch(resetState(DELETE_ALL_FILES_IN_SECTION));
      }
      if (create.version) {
        dispatch({ type: buildActionType(SECTIONS, ActionStatus.INCREASE), index: create.data?.sectionIndex });
        dispatch(resetState(CREATE_FILE));
      }
      if (remove.version) {
        dispatch({ type: buildActionType(SECTIONS, ActionStatus.DECREASE), index: remove.data?.sectionIndex });
        dispatch(resetState(DELETE_FILE));
      }
      if (addToSection.version) {
        dispatch({ type: buildActionType(SECTIONS, ActionStatus.INCREASE), index: addToSection.data?.sectionIndex });
        dispatch(resetState(ADD_FILE_TO_SECTION));
      }
      dispatch(resetState(FILES));
      if (toResetModal) {
      }
    }
    //eslint-disable-next-line
  }, [
    dispatch,
    sectionId,
    request,
    silent,
    status,
    update.version,
    upload.version,
    remove.version,
    create.version,
    remove,
    create,
    reorder.version,
    addToSection.version,
    deleteAllFilesInSection.version,
  ]);

  if (!sectionId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  return { data: data || [], status, version, entity };
};

export default useFiles;
